import React from "react";

export default function BridgeEnd() {
  return <img src="/assets/odontogram/bridge-end.svg" alt="brigde-end"></img>;
}
